export enum RiskCategoryFields {
  ID = 'id',
  CATEGORY_NAME = 'category_name',
  SUB_CATEGORY_NAME = 'sub_category_name',
}
